/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\Offers\OfferTableUser\OfferTableUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Thursday July 4th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday July 4th 2024 2:13:31 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { OfferUserType } from "Type/offer.type";
import { OfferRowUser } from "../OfferRowUserSingle/OfferRowUser";
import { useEffect, useMemo, useState } from "react";
import { TablePaper } from "Content/Table/TablePaper";
import OfferService from "Services/Offer/OfferService";

type OfferTableUserProps = {
    showUser?: boolean,
    Status?: string,
    carID?: string,
    companyID?: string,
    userID?: string,
};

export default function OfferTableUser(props: OfferTableUserProps) {
    const [offers, setOffers] = useState<OfferUserType[]>([]);

    useEffect(() => {
        const data = {
            status: props.Status,
            carID: props.carID,
            companyID: props.companyID,
            userID: props.userID
        };
        OfferService.getAllOffers(data).then((result) => {
            setOffers(result);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const offerKeysOffer = ["Date", "Update", "Vehicle", "RegNb", "InSellDate","InSellStatus", "Value", "Status", "Comments", "Action"];
    if (props.showUser) {
        offerKeysOffer.unshift("Commercial");
        offerKeysOffer.unshift("User");
    }

    const buildRows = (offers: OfferUserType[]) => {
        const offerToDisplay = [];
        for (let i = 0; i < offers.length; ++i)
            offerToDisplay.push(<OfferRowUser key={Math.random()} Offer={offers[i]} showUser={props.showUser} />);
        return offerToDisplay;
    };

    const offerValues = useMemo(() => {
        return buildRows(offers);
    }, [offers]);

    return (
        <TablePaper items={offerValues} headerList={offerKeysOffer} />
    );
};
